import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Switch,
  FormControlLabel,
} from '@material-ui/core'

import * as UserActionCreators from '../../actions/user'

class AlertSubscriptionToggleContainer extends React.Component {
  static propTypes = {
    communityId: PropTypes.number.isRequired,
    users: PropTypes.object.isRequired,
    subscriptionsByCommunity: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
  }

  static styles = () => ({
  })

  static mapStateToProps(state) {
    return {
      subscriptionsByCommunity: state.subscriptionsByCommunity,
      users: state.users,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      userActions: bindActionCreators(UserActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update()
  }

  toggleSubscription = () => {
    const { communityId, userActions } = this.props
    userActions.updateSubscription(communityId, !this.subscribed())
  }

  update() {
    const {
      communityId, userActions,
    } = this.props

    userActions.fetchSubscription(communityId)
    userActions.currentUser()
  }

  currentUser() {
    return this.props.users.me || {}
  }

  hasSubscriber() {
    return typeof this.subscribed() === 'boolean'
  }

  subscribed() {
    const {
      communityId, subscriptionsByCommunity,
    } = this.props

    return subscriptionsByCommunity[communityId]
  }

  render() {
    const {
      communityId, users, userActions, subscriptionsByCommunity,
      ...props
    } = this.props
    return (
      <FormControlLabel
        control={(
          <Switch
            disabled={!this.hasSubscriber()}
            checked={!!this.subscribed()}
            onChange={this.toggleSubscription}
            value="subscribed"
            color="primary"
          />
        )}
        label="Subscribe to alerts"
        {...props}
      />
    )
  }
}

export default connect(
  AlertSubscriptionToggleContainer.mapStateToProps,
  AlertSubscriptionToggleContainer.mapDispatchToProps,
)(withStyles(AlertSubscriptionToggleContainer.styles)(AlertSubscriptionToggleContainer))
